

function initFiltering() {

  var inputs = $(".filters form input[type=checkbox], .filters form input[type=hidden]");

  var getFilterParameters = function() {

    var parameters = {};

    inputs.each(function(ind, val) {

      var $val = $(val);
      var name = $val.attr("name");

      if (typeof parameters[name] === "undefined") {
        parameters[name] = [];
      }

      if ($val.is("[type=checkbox]")) {
        if ($val.is(":checked")) {
          parameters[name].push($val.val());
        }
      }
      else {
        parameters[name].push($val.val());
      }

    });

    var keys = Object.keys(parameters);
    var result = [];

    for (var i = 0, len = keys.length; i < len; i++) {
      var key = keys[i];

      result.push(key + "=" + parameters[key].join(","));
    }

    return result.join(";");
  }


  var initialParameters = getFilterParameters();

  $(".filter input[type=checkbox]").on("change", function() {

    var filter = $(this).closest(".filter");
    var clear  = filter.find(".filter__clear");

    if (filter.find("input[type=checkbox]:checked").length) 
    {
      clear.removeClass("filter__clear--hidden");
    }
    else {
      clear.addClass("filter__clear--hidden");
    }

  });

  $(".min-price-input, .max-price-input").on("change", function(e) {

    var filter = $(this).closest(".filter");
    var slider = filter.find("#price-slider");
    var max = parseInt(slider.attr("data-max"), 10);
    var min = parseInt(slider.attr("data-min"), 10);
    var minInput = $(this).hasClass("min-price-input") ? $(this) : filter.find(".min-price-input");
    var maxInput = $(this).hasClass("max-price-input") ? $(this) : filter.find(".max-price-input");
    var minVal = parseInt(minInput.val(), 10);
    var maxVal = parseInt(maxInput.val(), 10);
    var clear  = filter.find(".filter__clear");

    if (min != minVal || max != maxVal) {
      clear.removeClass("filter__clear--hidden");
    }
    else {
      clear.addClass("filter__clear--hidden");
    }

  });

  $(".filter__clear").on("click", function(e) {

    e.preventDefault();

    var filter = $(this).closest(".filter");
    var slider = filter.find("#price-slider");

    if (slider.length) {

      var max = parseInt(slider.attr("data-max"), 10);
      var min = parseInt(slider.attr("data-min"), 10);

      slider[0].noUiSlider.set([min, max]);

    }
    else {
      filter.find("input[type=checkbox]").attr("checked", false).prop("checked", false).change();
    }

  });

  $(".filter__view-more a").on("click", function(e) {

    e.preventDefault();

    var filter = $(this).closest(".filter");
    var overflow = filter.find(".filter__item--overflow");
    var more = $(this).find(".view-more");
    var less = $(this).find(".view-less"); 

    if (more.is(":visible")) 
    {
      more.hide();
      less.show();
      overflow.removeClass("filter__item--hidden");
    }
    else {
      more.show();
      less.hide();
      overflow.addClass("filter__item--hidden");
    }

    // Call resize, to calculate positioniong of fixed elements
    $(window).resize();
    $(window).scroll();

  });


  $(".filter input[type=checkbox], .filter input[type=hidden]").on("change", function() {
    
    var currentParameters = getFilterParameters();
    var button = $(".filters .filter-actions .btn--primary");

    if (currentParameters != initialParameters) {
      button.addClass("btn--bouncing");
    }
    else {
      button.removeClass("btn--bouncing");
    }
  });

  $(".btn-filter-clear").on("click", function(e) {
    e.preventDefault();
    
    $(".filter__clear").click();
  });

}

function reloadFiltering() {


  var inputs = $(".filters form input[type=checkbox], .filters form input[type=hidden]");

  $(".filter input[type=checkbox]").on("change", function() {

    var filter = $(this).closest(".filter");
    var clear  = filter.find(".filter__clear");

    if (filter.find("input[type=checkbox]:checked").length) 
    {
      clear.removeClass("filter__clear--hidden");
    }
    else {
      clear.addClass("filter__clear--hidden");
    }

  });

  $(".btn-filter-clear").on("click", function(e) {
    e.preventDefault();
    
    $(".filter__clear").click().removeClass("filter__clear--hidden");
  });

  $(".filter__view-more a").on("click", function(e) {

    e.preventDefault();

    var filter = $(this).closest(".filter");
    var overflow = filter.find(".filter__item--overflow");
    var more = $(this).find(".view-more");
    var less = $(this).find(".view-less"); 

    if (more.is(":visible")) 
    {
      more.hide();
      less.show();
      overflow.removeClass("filter__item--hidden");
    }
    else {
      more.show();
      less.hide();
      overflow.addClass("filter__item--hidden");
    }

    // Call resize, to calculate positioniong of fixed elements
    $(window).resize();
    $(window).scroll();

  });


  $(".min-price-input, .max-price-input").on("change", function(e) {

    var filter = $(this).closest(".filter");
    var slider = filter.find("#price-slider");
    var max = parseInt(slider.attr("data-max"), 10);
    var min = parseInt(slider.attr("data-min"), 10);
    var minInput = $(this).hasClass("min-price-input") ? $(this) : filter.find(".min-price-input");
    var maxInput = $(this).hasClass("max-price-input") ? $(this) : filter.find(".max-price-input");
    var minVal = parseInt(minInput.val(), 10);
    var maxVal = parseInt(maxInput.val(), 10);
    var clear  = filter.find(".filter__clear");

    if (min != minVal || max != maxVal) {
      clear.removeClass("filter__clear--hidden");
    }
    else {
      clear.addClass("filter__clear--hidden");
    }

  });

  $(".filter__clear").on("click", function(e) {

    e.preventDefault();

    var filter = $(this).closest(".filter");
    var slider = filter.find("#price-slider");

    if (slider.length) {

      var max = parseInt(slider.attr("data-max"), 10);
      var min = parseInt(slider.attr("data-min"), 10);

      var minInput = filter.find(".min-price-input");
      var maxInput = filter.find(".max-price-input");

      minInput.val(min);
      maxInput.val(max);

      slider[0].noUiSlider.set([min, max]);

    }
    else {
      filter.find("input[type=checkbox]").attr("checked", false).prop("checked", false).change();
    }

    $(this).addClass("filter__clear--hidden");

  });

  var container = $(".product-listing-content");
  var form = $(".filters form");
  var totalResults = $(".js-total-results");
  var request = null;

  var ajaxLoad = function(e) {

    if (e) {
      e.preventDefault();
    }

    if (request) {
      request.abort();
    }

    container.addClass("product-listing-content--loading");

    var url = form.attr("action") + "?" + form.serialize();
    history.replaceState({"filter": true}, document.title, url);

    request = $.ajax({
      type: "GET",
      url: url,
      complete: function() {
        container.removeClass("product-listing-content--loading");

        reuqest = null;
      },
      success: function(response) {
        var response = $(response);

        container.html(response);

        // Change product image on hover
        if (response.find("img.hover-img").length > 0) {
          response.find("img.main-img").each(function() {
            let $this = $(this);
            let imgSrc = $this.attr('src');
            let imgSrcHover = $this.next().data("src");
            let sectionItem = $this.closest('.section__item');
            
            sectionItem.on("mouseover", function() {
              $this.attr('src', imgSrcHover);
            });

            sectionItem.on("mouseout", function() {
              $this.attr("src", imgSrc);
            });
          });
        }

        if (window.ECMT) {
          window.ECMT.trackImpressions("main");
        }

        var total = 0;
        
        if (typeof container.find('.product-listing').data("total-results") !== 'undefined') {
          var total = parseInt(
            container.find('.product-listing').data("total-results"), 10
          );
        }

        var totalText = "";

        if (total == 1) {
          totalText = total + " резултат";
        }
        else {
          totalText = total + " резултата";
        }

        totalResults.text(totalText);

      }
    });

  };

  form.on("submit", ajaxLoad);

  inputs.on("change", function() {
    $(this).closest("form").submit();
  });

  $(".product-sort [name=\"order\"]").on("change", function(e) {
    e.preventDefault();

    form.find("[name=\"order\"]").val($(this).val()).change();
  });

}

reloadFiltering();
// initFiltering();